import instance from "../utils/network";

export interface ControllerLogItemResponse {
  id: number;
  createdAt: string;
  tournamentId: number;
  level: string;
  levelTime: string;
  nickname: string;
  type: string;
  paymentMethod: string;
  amount: string;
  stack: number;
  totalStack: number;
  totalEntry: number;
  isDeleted: boolean;
}

export interface ControllerLogResponse {
  totalCount: number;
  data: ControllerLogItemResponse[];
}
export function getControllerLog(
  tournamentId: number,
  page: number,
  limit: number,
  search?: string
): Promise<ControllerLogResponse> {
  return instance.get(
    `/seller/controller-log?tournamentId=${tournamentId}&page=${page}&limit=${limit}&search=${search}`
  );
}
